import React from "react";
const IconCheckboxSelected = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <rect x="2.5" y="2.5" width="15" height="15" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <path d="M5 9.26923L8.63636 12.5L15 6.5" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
  </svg>
);
export default IconCheckboxSelected;
